import type { RouterConfig } from "@nuxt/schema";
import { routes } from "@/router/routes";
import { scrollBehavior } from "@/router/scrollBehavior";

export default {
  routes: () => routes,
  scrollBehavior,
} satisfies RouterConfig;
